export const planKeyFactory = {
  billingFrequency: () => ["billingFrequency"],
  includedIn:()=>["includedIn"],
  category: () => ["planCategory"],
  subCategory: (categoryCode: string) => ["planSubCategory", categoryCode],
  filteredContractList: (categories?: any, subCategories?: any) => [
    "planFilteredContractList",
    categories,
    subCategories
  ],
  utilityServices: (utilityId: string) => ["planUtilityServices", utilityId],
  rate: (utilityId: string, utilityService: string) => ["planRate", utilityId, utilityService],
  parameter: (utilityId: string, utilityService: string | string[]) => ["planParameter", utilityId, utilityService],
  parameterValues: (utilityId: string, parameterId: string) => ["planParameterValues", utilityId, parameterId],
  detail: (planId: string | number) => ["planDetail", planId],
  detailByTab:(planId:string |number,tab:string)=> ["planDetailByTab", planId, tab],
  listForEdit: (utilityId: string, filters?: any) => ["planListForEdit", utilityId, filters],
  chargesChoices: () => ["planChargesChoices"],
  versionList: (planId: string) => ["planVersionList", planId],
  versionDetail: (planId: string, versionId: string) => ["planVersionDetail", planId, versionId],
  
};